// extracted by mini-css-extract-plugin
module.exports = {"viewContent":"DocumentListHeader_viewContent__fuaMI","label":"DocumentListHeader_label__uYGPg","switch":"DocumentListHeader_switch__HY9sY"};